import { useAtomValue } from 'jotai';

import { alertBannerAtom } from '../../store';
import { NcAlert } from '../NcAlert';

import '@consumer-bootstrap/netcredit.scss';

export const NcAlertBanner = () => {
  const {
    dismissible,
    heading,
    message,
    show,
    variant,
  } = useAtomValue(alertBannerAtom);

  return show && (
    <NcAlert className="nc-alert-banner" dismissible={dismissible} variant={variant}>
      <>
        <p className="banner-heading">{heading}</p>
        <p>{message}</p>
      </>
    </NcAlert>
  );
};
